import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { trackPageView } from '@/lib/ops/utils';

export function usePageView() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const path = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');
    const referrer = document.referrer || null;

    trackPageView(path, referrer);
  }, [pathname, searchParams]);
}

